

<p-sidebar
  #sidebar
  [(visible)]="display"
  [style]="{'width':'390px'}"
  position="right">

  <app-exams-filter
    *ngIf="display"
    [tipo]="tipoExamen"
    [tiposExamen]="tipoExamen==='periodicos'? tiposExamenPeriodicos : ( tipoExamen==='reevaluacion' ? tiposExamenReevaluacion : tiposExamenPorEnviar )"
    (updateCargadosOnParentList)="updateCargados($event)"
    (closeSidebar)="closeSidebar($event)">
  </app-exams-filter>
</p-sidebar>


<div class="p-fluid" style="margin: 28px;">
  <div *ngIf="errorSync">
    <p-messages severity="error">
      <ng-template pTemplate>
        <i class="pi pi-info-circle" style="margin-right: 10px"></i>
        Hay exámenes que no pudieron ser enviados, por favor comuníquese con el&nbsp;<b><u>centro de ayuda</u></b>
        &nbsp; de Conexia.
      </ng-template>
    </p-messages>
    <br>
  </div>
  <div class="p-grid">
    <div class="p-col-12" style="padding-bottom: 5px">
      <label class="header-title">Exámenes</label>
      <app-last-update (actualizarExamenes)="actualizar()"></app-last-update>
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-12 ">
      <p-tabView (activeIndexChange)="activeIndexChange($event)" [activeIndex]="activeIndex">

        <p-tabPanel [header]="'Periódicos ('+periodicosContentTodos.length+')'">
          <app-list
            (emitCloseExam)="updateExamOnAusente($event,'periodicos')"
            (refreshListEvent)="refreshExamsList('periodicos')"
            *ngIf="periodicosContent.length>=0 && !displaySpinnerPeriodicos"
            [listExams]="periodicosContent"
            [motivosCierre]="motivosCierre"
            [tipo]="'periodicos'"
            (resultadosEvent)="changeResultados($event)">
          </app-list>
          <app-cx-spinner *ngIf="displaySpinnerPeriodicos"></app-cx-spinner>
        </p-tabPanel>

        <p-tabPanel [header]="'Reconfirmación ('+reevaluacionContentTodos.length+')'">
          <app-list
            (emitCloseExam)="updateExamOnAusente($event,'reevaluacion')"
            (refreshListEvent)="refreshExamsList('reevaluacion')"
            *ngIf="reevaluacionContent.length>=0 && !displaySpinnerReevaluacion"
            [listExams]="reevaluacionContent"
            [motivosCierre]="motivosCierre"
            [tipo]="'reevaluacion'"
            (resultadosEvent)="changeResultados($event)">
          </app-list>
          <app-cx-spinner *ngIf="displaySpinnerReevaluacion"></app-cx-spinner>
        </p-tabPanel>

        <p-tabPanel [header]="'Cargados ('+cargadosContentTodos.length+')'">
          <app-list-cargados
            *ngIf="cargadosContent.length>=0 && !displaySpinnerCargados"
            [listExams]="cargadosContent"
            [motivosCierre]="motivosCierre"
            [tipo]="'cargados'">
          </app-list-cargados>
          <app-cx-spinner *ngIf="displaySpinnerCargados"></app-cx-spinner>
        </p-tabPanel>

        <p-tabPanel [header]="'Por enviar ('+enviarContentTodos.length+')'">
          <br>
          <app-list *ngIf="enviarContentTodos.length>0" [listExams]="enviarContent" [motivosCierre]="motivosCierre"
            [tipo]="'porEnviar'">
          </app-list>
          <app-empty-state *ngIf="enviarContentTodos.length <=0"
            [subTittle]="'Todos los exámenes fueron enviados correctamente'" [tittle]="'No hay exámenes'">
          </app-empty-state>
        </p-tabPanel>

      </p-tabView>
    </div>
  </div>
</div>
<p-confirmDialog #cd [closable]="true" [style]="{width: '500px'}" key="closeExam" styleClass="p-dialog-custom">
  <p-footer>
    <button (click)="cd.reject()" class="p-button-text" label="No, cancelar" pButton type="button"></button>
    <button (click)="cd.accept()" label="Si, cerrar examen" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog #cdc [closable]="false" [closeOnEscape]="true" [style]="{width: '500px'}" key="reassessmentComment"
  styleClass="p-dialog-custom">
  <p-footer>
    <button (click)="cdc.reject()" label="Cerrar comentario" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>

<app-modal-update-email [(display)]="displayEmailModal"></app-modal-update-email>
